import type { CSSProperties } from 'react';

/** Venc. Fiel / Venc. Sellos en grillas de empresas: `10/may/30`. */
export const EMPRESA_VENCIMIENTO_DATE_PATTERN = 'dd/MMM/yy';

/** Fecha de vencimiento ya pasada (`hoy > fecha`, comparación por día local). */
export const EMPRESA_VENCIMIENTO_EXPIRED_STYLE: CSSProperties = {
  color: 'var(--crm-form-warning-text, #b45309)',
  fontWeight: 700,
};

/** Actividad con `vencido = true` en tablero de nodos. */
export const ACTIVIDAD_VENCIDA_DATE_STYLE: CSSProperties = {
  color: '#dc2626',
  fontWeight: 700,
};
